// frontend/src/api/power.ts
import { api } from './client';

export interface PowerChannel {
  did: string;
  reading_type: 'amps' | 'watts' | 'volts';
  outlet_name: string | null;
  outlet_index: number | null;
  module_id: number;
}

export interface PowerDataPoint {
  timestamp: string;
  total_watts: number;
  [channelDid: string]: string | number | null;
}

export interface PowerResponse {
  channels: PowerChannel[];
  data: PowerDataPoint[];
  interval: string;
  downsampled: boolean;
  count: number;
}

export async function getPowerData(
  tankId: string,
  startDate: string,
  endDate: string,
  readingType?: string,
): Promise<PowerResponse> {
  const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
  if (readingType) params.set('reading_type', readingType);
  return api.get<PowerResponse>(`/api/tanks/${tankId}/power?${params}`);
}

export interface OutletRuntime {
  source_key: string;
  outlet_id: string;
  outlet_name: string;
  total_by_state: Record<string, number>;
  period_summary: Array<{ period: string; state: string; hours: number }>;
}

export interface OutletRuntimeResponse {
  outlets: OutletRuntime[];
  bucket_size: 'day' | 'week' | 'month';
  start_date: string;
  end_date: string;
  data_through: string | null;
}

export async function getOutletRuntime(
  tankId: string,
  startDate: string,
  endDate: string,
): Promise<OutletRuntimeResponse> {
  const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
  return api.get<OutletRuntimeResponse>(`/api/tanks/${tankId}/power/outlets?${params}`);
}
